<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import PageGrid from '../components/pageGrid.svelte';

	interface Props {
		content: ISbStoryData['content'] & {
			quote: string;
			subline: string;
		};
	}

	let { content }: Props = $props();
</script>

<div use:editable={content}>
	<PageGrid>
		<figure class="col-span-full text-center lg:col-start-5 lg:col-end-9">
			<blockquote class="font-serif text-[28px] font-normal leading-[33.60px] text-green-2">
				“{content.quote}”
			</blockquote>

			<figcaption class="mt-2 text-base font-normal leading-snug text-brown-2">
				{content.subline}
			</figcaption>
		</figure>
	</PageGrid>
</div>
